import { useEffect, useRef } from 'react';
import { isLoggedIn } from '../../app/auth';
import {
  refreshTokensSilently,
  needsTokenRefresh,
} from '../../lib/axios';
import { clearAuthSession } from '../../utils/tokenStorage';
import { queryClient } from '../../providers/query-client';

/** Interval (ms) to check token expiration. 60 seconds. */
const CHECK_INTERVAL_MS = 60_000;

/** Buffer before expiry (ms) to trigger refresh. Refresh when < 60 seconds left. */
const REFRESH_BUFFER_MS = 60_000;

/**
 * Runs when user is logged in. Periodically checks access token expiration
 * and refreshes silently when expired or about to expire.
 */
export default function TokenRefreshHandler() {
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!isLoggedIn()) return;

    const checkAndRefresh = async () => {
      if (!isLoggedIn()) return;

      if (!needsTokenRefresh(REFRESH_BUFFER_MS)) return;

      const success = await refreshTokensSilently();
      if (!success) {
        clearAuthSession();
        if (queryClient) {
          queryClient.clear();
        }
        window.location.replace('/#/');
      }
    };

    checkAndRefresh();
    intervalRef.current = setInterval(checkAndRefresh, CHECK_INTERVAL_MS);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  return null;
}
